import React,{useEffect,useState} from 'react'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Add from '@mui/icons-material/Add';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Controller } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import {useDispatch,useSelector} from "react-redux"
import {selectAllParentescos,fetchParentescos,getUtilityIsLoading} from './../../../redux/Utility/UtilitySlice'

import { 
    selectEmpleadosIsLoading,
    selectEmpleadosIsSuccess,
    selectEmpleadosMessage, 
    addNewEmpleadoComposicionFamiliar,
    fetchCambiarSuccess
} from '../../../redux/Empleados/EmpleadosSlice';

import swal from 'sweetalert';
import Loading from '../Loading/Loader';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	pt: 2,
	px: 4,
	pb: 3
};

const ComposicionFamiliarNuevo = ({openComposicionFamiliar,setOpenComposicionFamiliar,empleadoId}) => {
    
    // ? HOOK-FORM
    const {
        register,
        handleSubmit, 
        formState: {errors},
        control,
        setValue,
        reset 
    } = useForm({
        defaultValues: {
            empleadoId: 0,
            nombres: "",
            apellidos: "",
            sexo: "",
            fechaNacimiento: "",
            parentescoId: "",
            fechaNacimiento: new Date()
        }
    });
    
    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const parentescos = useSelector(selectAllParentescos);
    const isLoading = useSelector(getUtilityIsLoading);
    const isSuccess = useSelector(selectEmpleadosIsSuccess);
    const isLoadingEmpleado = useSelector(selectEmpleadosIsLoading)
    const empleaodMessage = useSelector(selectEmpleadosMessage)

    // ? HOOK-STATE
    const [openLoading, setOpenLoading] = useState(false);

    const onSubmit = (data) => {
        dispatch(addNewEmpleadoComposicionFamiliar({...data, empleadoId: Number(empleadoId)}));
    }

    const handleClose=()=>{
        setOpenComposicionFamiliar(false);
    }

    useEffect(() => {
        dispatch(fetchParentescos());
    },[])

    useEffect(() => {

        if(isSuccess === 'success' && empleaodMessage.length > 0){
			swal("Exitoso!", "Fue agregado el dependiente", "success");
            handleClose();
            reset();
            dispatch(fetchCambiarSuccess());
		}
        else if(isSuccess === 'error'){
			swal("Error!", empleaodMessage, "error");
            dispatch(fetchCambiarSuccess());
		}
    },[isSuccess, empleaodMessage])

    useEffect(()=>{
        if(!isLoading && !isLoadingEmpleado)
        {
            setOpenLoading(false)
        }else{
            setOpenLoading(true)
        }

    },[isLoading, isLoadingEmpleado])

  return (
    <Modal
    open={openComposicionFamiliar}
    onClose={handleClose}
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
>
    <Box sx={{ ...style, width: 700 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
            <div className="row">
                <h3 className="text-primary-mem text-center">Dependiente</h3>
            </div>
            <div className="row">
                <div className="col-5 me-0 pe-0">
                    <hr />
                </div>
                <div className="col-2 text-center">
                <Add className='text-primary-mem'></Add>
                </div>
                <div className="col-5 ms-0 ps-0 ">
                    <hr />
                </div>
            </div>
            <div className='row'>
                <div hidden >
                    <input {...register("empleadoId")}></input>
                </div>
                <div className='form-group'>
                    <label className='fw-bold'>Nombres</label>
                    <input {...register("nombres",{required:"El nombre es requerido"})} type="text" className='form-control'></input>
                    <p className='text-danger'>{errors.nombres?.message}</p>
                </div>
                <div className='form-group'>
                    <label className='fw-bold'>Apellidos</label>
                   <input type="text" {...register("apellidos",{required:"El apellido es requerido"})} className="form-control"></input>
                   <p className='text-danger'>{errors.apellidos?.message}</p>
                </div>
                <div className='form-group'>
                    <label className='fw-bold'>Sexo</label>
                    <select {...register("sexo",{required:"El sexo es requerido"})} className='form-control'>
                        <option value="">Seleccionar sexo</option>
                        <option value="Masculino">Masculino</option>
                        <option value="Femenino">Femenino</option>
                       
                    </select>
                    <p className='text-danger'>{errors.sexo?.message}</p>
                </div>
                <div className="form-group">
											<label className="fw-bold">Fecha Nacimiento</label>
											<Controller
												control={control}
                                                className="mb-3"
												name="ReactDatepicker"
												{...register('fechaNacimiento', {
													required: 'La fecha es requerida'
												})}
												render={({ field }) => (
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
                                                            inputFormat='dd/MM/yyyy'
															label={' '}
															mask="__/__/____"
															value={field.value}
															onChange={(e) => field.onChange(e)}
															renderInput={(params) => (
																<TextField
																	height={10}
																	className="form-control"
																	style={{ height: 10 }}
																	{...params}
																/>
															)}
														/>
													</LocalizationProvider>
												)}
											/>
                                             <p className='text-danger mt-3'>{errors.fechaNacimiento?.message}</p>
				</div>
                <div className='form-group'>
                    <label className='fw-bold'>Parentesco</label>
                    <select {...register("parentescoId",{required:"El parentesco es requerido"})} className='form-control'>
                        <option value={""}>Seleccionar parentesco</option>
                        {
                            parentescos && parentescos.length>0 &&(
                                parentescos.map(parentesco => <option key={parentesco.id} value={Number(parentesco.id)}>{parentesco.nombre}</option>)
                            )                        
                        }
                       
                    </select>
                    <p className='text-danger'>{errors.parentescoId?.message}</p>
                </div>
                <div className='d-flex justify-content-center'>
                <button type='submit' className='btn btn-primary-mem me-3' id='btn-guardar'>Guardar</button>
                <button type='button' className='btn btn-danger ' onClick={handleClose} id='btn-cancelar'>Cancelar</button>
                </div>
            </div>
        </div>
        </form>
        <Loading open={openLoading}></Loading>
    </Box>
   
</Modal>
  )
}

export default ComposicionFamiliarNuevo